module.exports = __webpack_public_path__ + "img-dashboard/register/image-circle.1d65fcf2.svg";